
<mat-checkbox (change)="checkedClicked($event)" class="example-margin"></mat-checkbox>